import { FileModel } from '../../typescript-angular-client';


export class SelectedEntities {
  private _selectedFiles: Array<FileModel>;
  private _selectedFolders: Array<FileModel>;

  get selectedFolders(): Array<FileModel> {
    return this._selectedFolders;
  }

  set selectedFolders(value: Array<FileModel>) {
    this._selectedFolders = value;
  }

  AddSelectedFile(file: FileModel) {
    if (this.selectedFiles == null) {
      this.selectedFiles = new Array<FileModel>();
    }

    const fileInArray = this.selectedFiles.filter((item) => item.Id === file.Id);

    if (fileInArray != null && fileInArray.length > 0) {
      const index: number = this.selectedFiles.indexOf(file);
      if (index !== -1) {
        this.selectedFiles.splice(index, 1);
      }
    } else {
      this.selectedFiles.push(file);
    }
  }

  get selectedFiles(): Array<FileModel> {
    return this._selectedFiles;
  }

  set selectedFiles(value: Array<FileModel>) {
    this._selectedFiles = value;
  }

  constructor() {
    this._selectedFolders = [];
    this._selectedFiles = [];
  }
}
